/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
    name: 'c-steps-list',
})
export default class StepsList extends Vue {
    @Prop() private title!: string;
    @Prop() private steps!: {sid: number, description: string}[];
}
